var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _vm.$store.getters.role == 1
        ? [
            _c("div", { staticClass: "container-fluid xyz" }, [
              _c("div", { staticClass: "page-header-top-container" }, [
                _c("div", { staticClass: "page-name" }, [_vm._v("Locations")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary waves-effect pull-right",
                    attrs: { type: "submit" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.addLocation.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("Add Location")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "admin-page-content" }, [
                _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c("vue-good-table", {
                        ref: "listLocationTable",
                        attrs: {
                          mode: "remote",
                          title: "List Location",
                          totalRows: _vm.totalRecords,
                          columns: _vm.columns,
                          rows: _vm.rows,
                          searchOptions: {
                            enabled: true,
                            placeholder: "Search by Location"
                          },
                          "pagination-options": {
                            enabled: true,
                            mode: "pages",
                            pageLabel: "Page",
                            position: "bottom",
                            perPage: _vm.serverParams.perPage,
                            setCurrentPage: _vm.serverParams.setCurrentPage,
                            perPageDropdown: [10, 20, 30, 40, 50],
                            dropdownAllowAll: false
                          }
                        },
                        on: {
                          "on-page-change": _vm.onPageChange,
                          "on-column-filter": _vm.onColumnFilter,
                          "on-per-page-change": _vm.onPerPageChange,
                          "on-sort-change": _vm.onSortChange,
                          "on-selected-rows-change": _vm.selectionChanged
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "pagination-bottom",
                              fn: function(props) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "vgt-wrap__footer crm" },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-sm-12 col-md-2 PerPage"
                                          },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                title: "Select Per Page",
                                                name: "customPerPage",
                                                id: "customPerPage",
                                                label: "text",
                                                clearable: false,
                                                searchable: false,
                                                filterable: false,
                                                options:
                                                  _vm.serverParams
                                                    .perPageDropdown,
                                                placeholder: "Select Per Page"
                                              },
                                              on: {
                                                change: _vm.changedValueTask,
                                                input: function($event) {
                                                  return _vm.changedValueTaskCustomPerPageTask()
                                                }
                                              },
                                              model: {
                                                value: _vm.serverParams.perPage,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.serverParams,
                                                    "perPage",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "serverParams.perPage"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mt-2 col-sm-12 col-md-2 RowsDisplay"
                                          },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "pageRowCount" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.paginationDisplayRowsTask
                                                  ) +
                                                    " of " +
                                                    _vm._s(_vm.totalRecords)
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-sm-12 col-md-6 Pagination"
                                          },
                                          [
                                            _c(
                                              "ul",
                                              { staticClass: "pagination" },
                                              [
                                                _c(
                                                  "li",
                                                  {
                                                    staticClass: "FirstPage",
                                                    attrs: {
                                                      title: "First Page"
                                                    }
                                                  },
                                                  [
                                                    Number(
                                                      _vm.serverParams.page
                                                    ) == 1
                                                      ? [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "page-link",
                                                              attrs: {
                                                                href:
                                                                  "javascript:void(0)"
                                                              }
                                                            },
                                                            [_vm._v("1")]
                                                          )
                                                        ]
                                                      : [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "page-link",
                                                              attrs: {
                                                                href:
                                                                  "javascript:void(0)"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.onPerticularPageClickTask(
                                                                    1
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("1")]
                                                          )
                                                        ]
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "page-item PreviousPage",
                                                    attrs: {
                                                      title: "Previous Page"
                                                    }
                                                  },
                                                  [
                                                    Number(
                                                      _vm.serverParams.page
                                                    ) == 1
                                                      ? [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "page-link",
                                                              attrs: {
                                                                href:
                                                                  "javascript:void(0)",
                                                                tabindex: "-1"
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-angle-left"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      : [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "page-link",
                                                              attrs: {
                                                                href:
                                                                  "javascript:void(0)",
                                                                tabindex: "-1"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.onPerticularPageClickTask(
                                                                    Number(
                                                                      _vm
                                                                        .serverParams
                                                                        .page
                                                                    ) - 1
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-angle-left"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _vm.pageNumberListTask() <
                                                _vm.displayPageTask
                                                  ? [
                                                      _vm._l(
                                                        _vm.pageNumberListTask(),
                                                        function(n, index) {
                                                          return [
                                                            n ==
                                                            Number(
                                                              _vm.serverParams
                                                                .page
                                                            )
                                                              ? _c(
                                                                  "li",
                                                                  {
                                                                    staticClass:
                                                                      "PagesClass page-item active",
                                                                    attrs: {
                                                                      title:
                                                                        "Page " +
                                                                        n,
                                                                      id:
                                                                        "pageNumber" +
                                                                        n
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "page-link",
                                                                        attrs: {
                                                                          href:
                                                                            "javascript:void(0)"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                " +
                                                                            _vm._s(
                                                                              n
                                                                            ) +
                                                                            "\n                                                            "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "li",
                                                                  {
                                                                    staticClass:
                                                                      "PagesClass page-item",
                                                                    attrs: {
                                                                      title:
                                                                        "Page " +
                                                                        n,
                                                                      id:
                                                                        "pageNumber" +
                                                                        n
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.onPerticularPageClickTask(
                                                                          n
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "page-link",
                                                                        attrs: {
                                                                          href:
                                                                            "javascript:void(0)"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                " +
                                                                            _vm._s(
                                                                              n
                                                                            ) +
                                                                            "\n                                                            "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                          ]
                                                        }
                                                      )
                                                    ]
                                                  : [
                                                      Number(
                                                        _vm.serverParams.page
                                                      ) <= _vm.pageCompareTask
                                                        ? [
                                                            _vm._l(
                                                              _vm.displayPageTask,
                                                              function(
                                                                n,
                                                                index
                                                              ) {
                                                                return [
                                                                  n ==
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  )
                                                                    ? _c(
                                                                        "li",
                                                                        {
                                                                          staticClass:
                                                                            "PagesClass page-item active",
                                                                          attrs: {
                                                                            title:
                                                                              "Page " +
                                                                              n,
                                                                            id:
                                                                              "pageNumber" +
                                                                              n
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "a",
                                                                            {
                                                                              staticClass:
                                                                                "page-link",
                                                                              attrs: {
                                                                                href:
                                                                                  "javascript:void(0)"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                                    " +
                                                                                  _vm._s(
                                                                                    n
                                                                                  ) +
                                                                                  "\n                                                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "li",
                                                                        {
                                                                          staticClass:
                                                                            "PagesClass page-item",
                                                                          attrs: {
                                                                            title:
                                                                              "Page " +
                                                                              n,
                                                                            id:
                                                                              "pageNumber" +
                                                                              n
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.onPerticularPageClickTask(
                                                                                n
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "a",
                                                                            {
                                                                              staticClass:
                                                                                "page-link",
                                                                              attrs: {
                                                                                href:
                                                                                  "javascript:void(0)"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                                    " +
                                                                                  _vm._s(
                                                                                    n
                                                                                  ) +
                                                                                  "\n                                                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                ]
                                                              }
                                                            )
                                                          ]
                                                        : Number(
                                                            _vm.serverParams
                                                              .page
                                                          ) >=
                                                          _vm.pageNumberListTask() -
                                                            (_vm.pageCompareTask -
                                                              1)
                                                        ? [
                                                            _vm._l(
                                                              _vm.pageNumberListTask(),
                                                              function(
                                                                n,
                                                                index
                                                              ) {
                                                                return [
                                                                  n >
                                                                  _vm.pageNumberListTask() -
                                                                    _vm.displayPageTask
                                                                    ? [
                                                                        n ==
                                                                        Number(
                                                                          _vm
                                                                            .serverParams
                                                                            .page
                                                                        )
                                                                          ? _c(
                                                                              "li",
                                                                              {
                                                                                staticClass:
                                                                                  "PagesClass page-item active",
                                                                                attrs: {
                                                                                  title:
                                                                                    "Page " +
                                                                                    n,
                                                                                  id:
                                                                                    "pageNumber" +
                                                                                    n
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "a",
                                                                                  {
                                                                                    staticClass:
                                                                                      "page-link",
                                                                                    attrs: {
                                                                                      href:
                                                                                        "javascript:void(0)"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                                                        " +
                                                                                        _vm._s(
                                                                                          n
                                                                                        ) +
                                                                                        "\n                                                                    "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "li",
                                                                              {
                                                                                staticClass:
                                                                                  "PagesClass page-item",
                                                                                attrs: {
                                                                                  title:
                                                                                    "Page " +
                                                                                    n,
                                                                                  id:
                                                                                    "pageNumber" +
                                                                                    n
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.onPerticularPageClickTask(
                                                                                      n
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "a",
                                                                                  {
                                                                                    staticClass:
                                                                                      "page-link",
                                                                                    attrs: {
                                                                                      href:
                                                                                        "javascript:void(0)"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                                                        " +
                                                                                        _vm._s(
                                                                                          n
                                                                                        ) +
                                                                                        "\n                                                                    "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                      ]
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            )
                                                          ]
                                                        : [
                                                            _vm._l(
                                                              _vm.pageNumberListTask(),
                                                              function(
                                                                n,
                                                                index
                                                              ) {
                                                                return n >=
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) -
                                                                    (_vm.pageCompareTask -
                                                                      1) &&
                                                                  n <=
                                                                    Number(
                                                                      _vm
                                                                        .serverParams
                                                                        .page
                                                                    ) +
                                                                      (_vm.pageCompareTask -
                                                                        1)
                                                                  ? [
                                                                      n ==
                                                                      Number(
                                                                        _vm
                                                                          .serverParams
                                                                          .page
                                                                      )
                                                                        ? _c(
                                                                            "li",
                                                                            {
                                                                              staticClass:
                                                                                "PagesClass page-item active",
                                                                              attrs: {
                                                                                title:
                                                                                  "Page " +
                                                                                  n,
                                                                                id:
                                                                                  "pageNumber" +
                                                                                  n
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticClass:
                                                                                    "page-link",
                                                                                  attrs: {
                                                                                    href:
                                                                                      "javascript:void(0)"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                                                    " +
                                                                                      _vm._s(
                                                                                        n
                                                                                      ) +
                                                                                      "\n                                                                "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "li",
                                                                            {
                                                                              staticClass:
                                                                                "PagesClass page-item",
                                                                              attrs: {
                                                                                title:
                                                                                  "Page " +
                                                                                  n,
                                                                                id:
                                                                                  "pageNumber" +
                                                                                  n
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onPerticularPageClickTask(
                                                                                    n
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticClass:
                                                                                    "page-link",
                                                                                  attrs: {
                                                                                    href:
                                                                                      "javascript:void(0)"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                                                    " +
                                                                                      _vm._s(
                                                                                        n
                                                                                      ) +
                                                                                      "\n                                                                "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                    ]
                                                                  : _vm._e()
                                                              }
                                                            )
                                                          ]
                                                    ],
                                                _vm._v(" "),
                                                _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "page-item NextPage",
                                                    attrs: {
                                                      title: "Next Page"
                                                    }
                                                  },
                                                  [
                                                    Number(
                                                      _vm.serverParams.page
                                                    ) ==
                                                    _vm.pageNumberListTask()
                                                      ? [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "page-link",
                                                              attrs: {
                                                                href:
                                                                  "javascript:void(0)"
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-angle-right"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      : [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "page-link",
                                                              attrs: {
                                                                href:
                                                                  "javascript:void(0)"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.onPerticularPageClickTask(
                                                                    Number(
                                                                      _vm
                                                                        .serverParams
                                                                        .page
                                                                    ) + 1
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-angle-right"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "li",
                                                  {
                                                    staticClass: "LastPage",
                                                    attrs: {
                                                      title: "Last Page"
                                                    }
                                                  },
                                                  [
                                                    Number(
                                                      _vm.serverParams.page
                                                    ) ==
                                                    _vm.pageNumberListTask()
                                                      ? [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "page-link",
                                                              attrs: {
                                                                href:
                                                                  "javascript:void(0)",
                                                                tabindex: "-1"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.pageNumberListTask()
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      : [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "page-link",
                                                              attrs: {
                                                                href:
                                                                  "javascript:void(0)",
                                                                tabindex: "-1"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.onPerticularPageClickTask(
                                                                    _vm.pageNumberListTask()
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.pageNumberListTask()
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                  ],
                                                  2
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                          },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "pageJumpLabel" },
                                              [_vm._v("Page : ")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.jumpToPageTask,
                                                  expression: "jumpToPageTask"
                                                }
                                              ],
                                              staticClass:
                                                "form-control form-control-sm",
                                              attrs: {
                                                type: "text",
                                                name: "jumpToPageTask",
                                                id: "jumpToPageTask",
                                                placeholder: "Page"
                                              },
                                              domProps: {
                                                value: _vm.jumpToPageTask
                                              },
                                              on: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.jumpToPageInTask.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.jumpToPageTask =
                                                    $event.target.value
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              }
                            },
                            {
                              key: "table-row",
                              fn: function(props) {
                                return [
                                  props.column.field == "actions"
                                    ? _c("span", [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary btn-sm",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                return _vm.editLocation(
                                                  props.row.location_id
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-pencil",
                                              attrs: { "aria-hidden": "true" }
                                            })
                                          ]
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              props.formattedRow[
                                                props.column.field
                                              ]
                                            ) +
                                            "\n                                "
                                        )
                                      ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          732068840
                        )
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "modal fade location-modal",
                  attrs: { id: "locationModal", role: "dialog" }
                },
                [
                  _c("div", { staticClass: "modal-dialog modal-sm" }, [
                    _c("div", { staticClass: "modal-content" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-body" }, [
                        _c(
                          "div",
                          {
                            staticClass: "form-group",
                            attrs: { id: "location" }
                          },
                          [
                            _c("label", { attrs: { for: "start_ticket_no" } }, [
                              _vm._v("Location")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.locationData.location,
                                  expression: "locationData.location"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", name: "location" },
                              domProps: { value: _vm.locationData.location },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.locationData,
                                    "location",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.error.location_error
                              ? _c("label", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.error.location_error))
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group", attrs: { id: "state" } },
                          [
                            _c("label", [_vm._v("Select State")]),
                            _vm._v(" "),
                            _c("v-select", {
                              attrs: {
                                name: "selectedState",
                                placeholder: "Type state here",
                                label: "name",
                                options: _vm.stateOptions
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onChnageState()
                                }
                              },
                              model: {
                                value: _vm.selectedState,
                                callback: function($$v) {
                                  _vm.selectedState = $$v
                                },
                                expression: "selectedState"
                              }
                            }),
                            _vm._v(" "),
                            _vm.error.state_error
                              ? _c("label", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.error.state_error))
                                ])
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-group my-5",
                            attrs: { id: "timezone" }
                          },
                          [
                            _c("label", [_vm._v("Select TimeZone")]),
                            _vm._v(" "),
                            _c("v-select", {
                              attrs: {
                                name: "selectedtimezone",
                                placeholder: "Type timezone here",
                                label: "name",
                                options: _vm.timezoneOptions
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onChnageTimeZone()
                                }
                              },
                              model: {
                                value: _vm.selectedtimezone,
                                callback: function($$v) {
                                  _vm.selectedtimezone = $$v
                                },
                                expression: "selectedtimezone"
                              }
                            }),
                            _vm._v(" "),
                            _vm.error.timezone_error
                              ? _c("label", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.error.timezone_error))
                                ])
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-group",
                            attrs: { id: "department" }
                          },
                          [
                            _c("label", [_vm._v("Select Department")]),
                            _vm._v(" "),
                            _c("v-select", {
                              attrs: {
                                name: "selecteddepartment",
                                placeholder: "Type department here",
                                label: "name",
                                options: _vm.departmentOptions
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onChnageDepartment()
                                }
                              },
                              model: {
                                value: _vm.selecteddepartment,
                                callback: function($$v) {
                                  _vm.selecteddepartment = $$v
                                },
                                expression: "selecteddepartment"
                              }
                            }),
                            _vm._v(" "),
                            _vm.error.department_error
                              ? _c("label", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.error.department_error))
                                ])
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "start_ticket_no" } }, [
                            _vm._v("Start Ticket Number")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.locationData.start_ticket_no,
                                expression: "locationData.start_ticket_no"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              name: "start_ticket_no",
                              id: "start_ticket_no"
                            },
                            domProps: {
                              value: _vm.locationData.start_ticket_no
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.locationData,
                                  "start_ticket_no",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", { attrs: { for: "ip-address" } }, [
                              _vm._v("Enter IP Address")
                            ]),
                            _vm._v(" "),
                            _c("vue-ip-input", {
                              staticClass: "form-control",
                              attrs: {
                                ip: _vm.locationData.ip_address,
                                "on-change": _vm.onIpChange,
                                "on-blur": _vm.onIpBlur,
                                type: "text",
                                name: "ip-address",
                                id: "ip-address"
                              }
                            }),
                            _vm._v(" "),
                            _vm.error.ip_address
                              ? _c("label", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.error.ip_address))
                                ])
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Select Printer")]),
                            _vm._v(" "),
                            _c("v-select", {
                              attrs: {
                                name: "selectedPrinter",
                                placeholder: "Type printer here",
                                label: "printer_version",
                                options: _vm.printerOptions
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onChnagePrinter()
                                }
                              },
                              model: {
                                value: _vm.selectedPrinter,
                                callback: function($$v) {
                                  _vm.selectedPrinter = $$v
                                },
                                expression: "selectedPrinter"
                              }
                            }),
                            _vm._v(" "),
                            _vm.error.printer_error
                              ? _c("label", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.error.printer_error))
                                ])
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group pt-5" },
                          [
                            _c("label", { attrs: { for: "ip-address" } }, [
                              _vm._v("Shop Close Time")
                            ]),
                            _vm._v(" "),
                            _c("date-picker", {
                              staticClass: "form-control",
                              attrs: {
                                config: _vm.bootstrapOptionsTime,
                                placeholder: "Select Close Time",
                                name: "bootstrapdate1"
                              },
                              model: {
                                value: _vm.locationData.close_time,
                                callback: function($$v) {
                                  _vm.$set(_vm.locationData, "close_time", $$v)
                                },
                                expression: "locationData.close_time"
                              }
                            }),
                            _vm._v(" "),
                            _vm.error.ip_address
                              ? _c("label", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.error.closeTime))
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-danger",
                            attrs: { type: "button", "data-dismiss": "modal" }
                          },
                          [_vm._v("Close")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-warning",
                            attrs: { id: "updateBtn" },
                            on: {
                              click: function($event) {
                                return _vm.updateLocation()
                              }
                            }
                          },
                          [_vm._v("Update")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-warning",
                            attrs: { id: "saveBtn" },
                            on: {
                              click: function($event) {
                                return _vm.saveLocation()
                              }
                            }
                          },
                          [_vm._v("Save")]
                        )
                      ])
                    ])
                  ])
                ]
              )
            ])
          ]
        : [_c("no-permission")],
      _vm._v(" "),
      _c("app-footer")
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h4",
        { staticClass: "modal-title", attrs: { id: "editModelTitle" } },
        [_vm._v("Edit Printer")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: { type: "button", "data-dismiss": "modal" }
        },
        [_vm._v("×")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26eb4dba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26eb4dba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListLocation.vue
// module id = null
// module chunks = 